import { Chip, Tooltip, type ChipProps } from '@mui/material'
import { LockedPadlockOMIcon } from '@omnea-app/icons'

type Props = {
  label: string
  tooltip: string
  size?: ChipProps['size']
}

export const ConfidentialChip = ({ label, tooltip, size = 'small' }: Props) => (
  <Tooltip title={tooltip}>
    <Chip size={size} icon={<LockedPadlockOMIcon />} label={label} />
  </Tooltip>
)
